import { IpRestrictionTranslator } from 'src/translators'
import { useGetAllowedIpsQuery } from 'src/types/generated'

export const useGetIpRestriction = () => {
  const { loading, data, error, refetch } = useGetAllowedIpsQuery()

  return {
    loading,
    ipRestriction:
      data && data.allowedIps ? IpRestrictionTranslator.toEntity(data.allowedIps) : null,
    error,
    refetch,
  }
}
